import { CHANGE_ALEX_STATE } from './actions';
import ALEX_STATES from '../AlexStates';

const initialState = {
  alexState: ALEX_STATES.INACTIVE,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_ALEX_STATE:
      return { ...state, alexState: payload };
    default:
      return state;
  }
};
